export const round = (value: number): number => {
  return Math.round(value * 1e5) / 1e5;
};

const BROWSER_DEFAULT_FONT_SIZE = 16;
export const rem = (px: number): string =>
  `${round(px / BROWSER_DEFAULT_FONT_SIZE)}rem`;
